import "./App.css";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import { lazy, Suspense } from "react";

import Header from "./Utils/Header/Header";
import Loader from "./Utils/Loader/Loader";
import ScrollToTop from "./Utils/ScrollToTop";
import AbstractForm from "./Abstract/AbstractForm";
import Scientific from "./Scientific/Scientific";

const Home = lazy(() => import(/* webpackChunkName: "Home" */ "./Home/Home"));

const About = lazy(() => import(/* webpackChunkName: "About" */ "./About/About"));

const Events = lazy(() => import(/* webpackChunkName: "Events" */ "./Events/Events"));

const RegistrationForm = lazy(() => import(/* webpackChunkName: "Events" */ "./RegistrationForm/RegistrationForm"));

const FacultyReg = lazy(() => import(/* webpackChunkName: "Events" */ "./FacultyRegistration/FacultyReg"));

const ScientificSchedule = lazy(() => import(/* webpackChunkName: "Events" */ "./ScientificSchedule/ScientificSchedule"));

const HealthcareEducation = lazy(() => import(/* webpackChunkName: "Events" */ "./HealthcareEducation/HealthcareEducation"));

const Cases = lazy(() => import(/* webpackChunkName: "Events" */ "./Cases/Cases"));

const CasesDetail = lazy(() => import(/* webpackChunkName: "Events" */ "./Cases/CasesDetail"));

const Gallery = lazy(() => import(/* webpackChunkName: "Events" */ "./Gallery/Gallery"));

const Notices = lazy(() => import(/* webpackChunkName: "Events" */ "./Notices/Notices"));

const Policy = lazy(() => import(/* webpackChunkName: "Policy" */ "./Policy/Policy"));

const Contact = lazy(() => import(/* webpackChunkName: "Contact" */ "./Contact/Contact"));

const theme = createTheme({
  palette: {
    primary: {
      main: "#40509B",
    },
    secondary: {
      main: "#813A8D",
    },
  },
});

const SuspenseLayout = () => (
  <>
    <Header />

    <Suspense
      fallback={
        <div className="loader-container">
          <Loader />
        </div>
      }>
      <Outlet />
    </Suspense>
  </>
);
function App() {
  return (
    <ThemeProvider theme={theme}>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route element={<SuspenseLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route exact path="/events" element={<Events />} />
            <Route path="/event/:slug/register" element={<RegistrationForm />} />
            <Route path="/event/:slug/abstract" element={<AbstractForm />} />
            <Route path="/event/:slug/scientific-program" element={<Scientific />} />
            <Route path="/event/:slug/faculty-register" element={<FacultyReg />} />

            <Route path="/scientific-schedule" element={<ScientificSchedule/>} />
            <Route path="/healthcare-education" element={< HealthcareEducation/>} />
            <Route path="/cases" element={<Cases />} />
            <Route path="/cases-details" element={<CasesDetail />} />

            <Route path="/photo-gallery" element={<Gallery />} />
            <Route path="/notices" element={<Notices />} />
            <Route path="/policy/:name" element={<Policy />} />
            <Route path="/contact" element={<Contact />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
